import { colors, fontSizes, fontWeights } from 'theme'
import css from 'styled-jsx/css'

export default css`
  .react-tabsul li{
    justify-content: left;
  }
  .container-Profile{

  }
  .conteiner-info{
    padding: 1rem;
  }
  .conteiner-info  h4{
    margin-bottom:0;
  }
  
  .controls{
    margin-top: 1rem;
  }

  .collapser-title {
    margin: 0;
  }

  .parent-selector {
    padding: 0;
  }

  .search-container {
    margin-bottom: 1.5rem;
  }

  .suggested-parents h6 {
    margin: 0 0 1rem 0;
    color: ${colors.text};
    font-size: 0.9rem;
    font-weight: bold;
  }

  .parent-option {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.75rem;
    margin-bottom: 0.5rem;
    border: 1px solid ${colors.border || '#e0e0e0'};
    border-radius: 4px;
    background-color: ${colors.background || '#fff'};
    position: relative;
  }

  .parent-info {
    flex: 1;
    min-width: 0;
  }

  .parent-name {
    font-weight: bold;
    color: ${colors.text};
    margin-bottom: 0.25rem;
  }

  .parent-email {
    font-size: 0.85rem;
    color: ${colors.alpha(colors.black, 0.5)};
  }

  .parent-phone {
    font-size: 0.85rem;
    color: ${colors.alpha(colors.black, 0.5)};
  }

  .parent-actions {
    flex-shrink: 0;
    margin-left: 1rem;
  }

  .parent-option :global(.delete-button) {
    margin-left: 0.5rem;
  }

  @media (max-width: 768px) {
    .parent-option {
      flex-direction: column;
      align-items: stretch;
      padding: 1rem 0.75rem 0.75rem 0.75rem;
    }

    .parent-info {
      padding-right: 2rem;
      margin-bottom: 1rem;
    }

    .parent-name {
      word-wrap: break-word;
      overflow-wrap: break-word;
    }

    .parent-email {
      display: block;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 100%;
      word-wrap: break-word;
      overflow-wrap: break-word;
    }

    .parent-phone {
      word-wrap: break-word;
      overflow-wrap: break-word;
    }

    .parent-actions {
      width: 100%;
      margin-left: 0;
    }

    .parent-actions :global(button) {
      width: 100%;
    }

    .parent-option :global(.delete-button) {
      position: absolute;
      top: 0.5rem;
      right: 0.5rem;
      min-width: auto;
      width: 24px;
      height: 24px;
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      font-size: 1rem;
      line-height: 1;
      margin-left: 0;
    }
  }

  @media (max-width: 480px) {
    .parent-option {
      padding: 1rem 0.5rem 0.5rem 0.5rem;
    }

    .parent-name {
      font-size: 0.9rem;
    }

    .parent-email,
    .parent-phone {
      font-size: 0.8rem;
    }
  }

  .no-results {
    padding: 1rem;
    text-align: center;
    color: ${colors.textSecondary || '#666'};
    font-style: italic;
    border: 1px dashed ${colors.border || '#e0e0e0'};
    border-radius: 4px;
  }

  .title {
    font-weight: bold;
    margin-top: 0.5rem;
  }

  .conteiner-info .container-profile :global(.editor-form-text .quill){
    margin-top: 0;
  }

  .about-label, .experience-label {
    font-size: ${fontSizes.small};
    padding: 0.5rem 0;
    font-weight: ${fontWeights.semiBold};
    margin: 1rem 0 0;
  }
`

export const userAvatar = css`
  .picture-profile{
    height: 150px;
    width: 150px;
    border-radius: 50%;
    justify-content: center;
    margin: auto;
    margin-bottom: 1rem;
    position: relative;
  }
  .picture-profile span{
    font-size: 3.2rem;
    vertical-align: middle;
    padding-top: 25%;
    text-align: center;
    display: block;
    //color:${colors.white} !important;
  }

  .user-profile{
    text-align: center;
  }
  .user-profile > p{
    color: ${colors.text};
    font-weight: bold;
    font-size: 1.2rem;
    margin: 0;
  }
  .user-profile > span{
    color: ${colors.primary};
    font-size: .9rem;
  }
  
  .information-profile{
    margin-top: 0.5rem;
  }
  .information-profile p{
    font-size: .75rem;
    margin-bottom: 1.5rem;
  }
  .information-profile .title {
    font-weight: bold;
    margin-bottom: 1rem;
  }
  .information-profile span{
    font-size: .75rem;
  }
`

export const passwordProfile = css`
.password-profile :global(.facebook-button){
  height: 2.5rem;
  padding: 0 1rem;
}
.password-profile :global(.facebook-button p){
  margin: 0;
}
.password-profile :global(.ion-social-facebook){
  margin: 0 .5rem;
}
`

export const profileGlobals = css`
.picture-profile :global(.overlay) {
  opacity: 0;
}
.picture-profile :global(.add-image-profile:hover .overlay) {
  background: ${colors.alpha(colors.black, 0.5)};
  color: ${colors.white};
  font-size: 3.2rem;
  width: 150px;
  height: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  opacity: 1;
  transition: 120ms linear opacity;
  cursor: pointer;
  position: absolute;
  top: 0;
  left: 0;
}
`

export const nexsiteStyles = css`
  .title {
    font-weight: bold;
    font-size: ${fontSizes.small};
  }

  a.nexsite {
    color: ${colors.primary};
    font-size: ${fontSizes.small};
  }
`
